import { useMutation } from '@tanstack/react-query';
import axiosInstance from './axios';

export const useSalesInvoiceSettlement = () => {
  return useMutation({
    mutationKey: ['useSalesInvoiceSettlement'],
    mutationFn: async (postData: {
      salesId: string | undefined;
      amountPaid: number;
      paymentDate: string;
    }) => {
      const { data } = await axiosInstance.post(
        '/sales/invoice/settlement',
        postData
      );
      return data;
    },
  });
};
